import React from 'react';
import {
  SkeletonAvatar,
  SkeletonCircle,
  SkeletonLine,
  SkeletonPill,
} from '../Skeleton';

type QuickTaskSkeletonListProps = {
  count?: number;
  showSource?: boolean;
  label?: string;
};

const normalizeCount = (count: unknown, fallback = 3) => Math.max(1, Number(count) || fallback);

export default function QuickTaskSkeletonList({
  count = 3,
  showSource = true,
  label = 'クイックタスクを読み込み中...',
}: QuickTaskSkeletonListProps) {
  const rows = Array.from({ length: normalizeCount(count) }, (_, index) => index);

  return (
    <div className="qt-panel__list qt-skeleton-list" role="status" aria-live="polite">
      {rows.map((index) => (
        <div
          key={`quick-task-skeleton-${index}`}
          className="qt-row qt-row--skeleton"
          aria-hidden="true"
          style={{ '--qt-skeleton-index': index } as React.CSSProperties}
        >
          <SkeletonCircle className="qt-skeleton__check" size={26} />
          <div className="qt-row__content">
            <div className="qt-row__body">
              <span className="qt-row__titleRow">
                <SkeletonCircle className="qt-skeleton__dot" size={8} />
                <SkeletonLine className="qt-skeleton__title" />
              </span>
              <SkeletonLine className="qt-skeleton__memo" />
              {showSource ? (
                <span className="qt-skeleton__sourceRow">
                  <SkeletonCircle className="qt-skeleton__sourceIcon" size={12} />
                  <SkeletonLine className="qt-skeleton__source" />
                </span>
              ) : null}
            </div>
            <div className="qt-row__meta qt-skeleton__meta">
              <SkeletonPill className="qt-skeleton__due" />
              <span className="qt-skeleton__assignee">
                <span className="qt-row__avatars" aria-hidden="true">
                  <SkeletonAvatar className="qt-row__avatar qt-skeleton__avatar" size={20} />
                  <SkeletonAvatar className="qt-row__avatar qt-skeleton__avatar" size={20} />
                </span>
                <SkeletonLine className="qt-skeleton__assigneeName" />
              </span>
            </div>
          </div>
        </div>
      ))}
      <span className="sr-only">{label}</span>
    </div>
  );
}
